var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStatusUndecided = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19zm-.388 12.72c-.17 0-.328.032-.475.095a1.318 1.318 0 0 0-.38.27c-.106.105-.19.231-.254.38a1.193 1.193 0 0 0 0 .934c.064.147.148.274.254.38.084.084.21.163.38.237.147.063.306.095.475.095.18 0 .337-.032.475-.095.169-.074.295-.153.38-.238a1.198 1.198 0 0 0 .348-.855c0-.18-.032-.337-.095-.475a1.198 1.198 0 0 0-.253-.38 1.198 1.198 0 0 0-.38-.253 1.122 1.122 0 0 0-.475-.095zm.348-9.294c-.348 0-.665.031-.95.095a5.696 5.696 0 0 0-.807.237 4.613 4.613 0 0 0-.697.38 5.645 5.645 0 0 0-.586.444l.507.823a.432.432 0 0 0 .411.237.51.51 0 0 0 .285-.095l.365-.221a2.596 2.596 0 0 1 1.282-.333c.222 0 .417.032.586.095.19.074.343.159.459.254a.95.95 0 0 1 .285.38c.074.18.11.348.11.506 0 .296-.057.55-.173.76a2.518 2.518 0 0 1-.444.555c-.285.253-.47.411-.554.475-.274.19-.464.332-.57.427-.158.127-.3.29-.427.49-.116.18-.175.38-.175.602v.143l.143 1.283h1.33l.19-1.156c.032-.159.11-.312.238-.46.147-.147.306-.284.474-.411l.586-.444c.254-.19.449-.374.586-.554.18-.221.322-.48.428-.776.126-.327.19-.67.19-1.029 0-.4-.074-.775-.222-1.124a2.44 2.44 0 0 0-.633-.855 2.765 2.765 0 0 0-.966-.538 3.935 3.935 0 0 0-1.251-.19z",
    fill: "#02607F"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStatusUndecided);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-status-undecided.b18271041b412667834b569428deeee2.svg";